import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';

console.log('🔍 Main.tsx is executing - Robust App version');

const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error('❌ Root element not found!');
  document.body.innerHTML =
    '<h1 style="color: red; padding: 20px;">Error: Root element not found!</h1>';
} else {
  console.log('✅ Root element found, mounting full React app');
  try {
    const root = createRoot(rootElement);
    root.render(
      <StrictMode>
        <App />
      </StrictMode>
    );
    console.log('✅ Full React app mounted successfully');
  } catch (error) {
    console.error('❌ Error mounting React app:', error);
    rootElement.innerHTML = `<h1 style="color: red; padding: 20px;">React Error: ${error}</h1>`;
  }
}
